import {useEffect, useRef} from 'react';

export const useInfiniteScroll = (callback, dependencies = []) => {
    const sentinelRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    callback();
                }
            },
            {threshold: 1}
        );

        if (sentinelRef.current) observer.observe(sentinelRef.current);

        return () => {
            if (sentinelRef.current) observer.unobserve(sentinelRef.current);
        };
    }, dependencies);

    return sentinelRef;
};